export default  {
  name: "credit",
  path: "/credit",
  component: () => import("@/views/member/credit"),
  redirect: {
    name: "creditApply"
  },
  meta: {
    layout: "default",
    isActive: false,
    text: "알관리",
    icon: "pt.svg"
  },
  children: [
    {
      name: 'creditApply',
      path: '/credit/credit/apply',
      component: () => import('@/views/member/credit/pages/apply'),
      meta: {
        menuMember: true,
        text: '알 신청내역',
        done: true
      }
    },
    {
      name: 'creditExchange',
      path: '/credit/credit/exchange',
      component: () => import('@/views/member/credit/pages/exchange'),
      meta: {
        menuMember: true,
        text: '알 환전내역',
        done: true
      }
    }
  ]
};
